import { css } from "@emotion/css";

export const styles = {
  content: css({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
  }),
  logo: css({
    marginBottom: "50px",
    marginTop: "5rem",
    width: "100px",
  }),
};
